import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { RetreatWidget } from './RetreatWidget'

class HoldstyringRetreatElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return RetreatWidget
  }

  // Supported HTML attributes:
  //   retreat-id="<uuid>"  — which retreat to render (required).
  //   hide-image           — boolean; omit the hero image so the widget opens
  //                          with a plain title/dates banner instead. For sites
  //                          that already show their own imagery around the embed.
  protected getWidgetProps() {
    const hideImage = this.getAttribute('hide-image')
    return {
      retreatId: this.getAttribute('retreat-id') || undefined,
      hideImage: hideImage !== null && hideImage !== 'false' && hideImage !== '0',
    }
  }
}

if (!customElements.get('holdstyring-retreat')) {
  customElements.define('holdstyring-retreat', HoldstyringRetreatElement)
}

export { HoldstyringRetreatElement }
